import { TranslationKey, TranslationKeys } from './translations-keys';

export const enGBTranslations: Record<TranslationKey, string> = {
    [TranslationKeys.PUPIL]: 'pupil',
    [TranslationKeys.PUPILS]: 'pupils',
};
